export default __webpack_public_path__ + "static/media/splash.de6c4d1e.svg";